import {initPage} from "./init-page";
import {renderGroupPage} from "./render-group-page";

window.addEventListener(`load`, () => {
  initPage();
  renderGroupPage(catalogList);
});
